import React from "react";
import "./style.scss";
import PreSalesCheckoutInStore from "../../sections/presales-checkout-in-store";
import PreSalesCheckoutOnline from "../../sections/presales-checkout-online";
import { staffInfoSelector } from "../../selectors/application";
import { connect } from "react-redux";

const PreSalesCheckout = props => {
  const { staffInfo } = props;
  if (staffInfo) {
    return <PreSalesCheckoutInStore {...{ ...props, staffInfo }} />;
  } else {
    return <PreSalesCheckoutOnline {...props} />;
  }
};
const mapStateToProps = state => ({
  staffInfo: staffInfoSelector(state)
});
export default connect(mapStateToProps)(PreSalesCheckout);
